module.exports = __webpack_public_path__ + "static/media/sadari_result.f92d83d4.mp3";